import React from 'react';

import { createTheme, ThemeProvider, StyledEngineProvider, responsiveFontSizes } from '@mui/material/styles';
import { useExperiments } from '@utils/experiments';

declare module '@mui/material/styles' {
  interface Theme {
    maligue: {
      red: string;
      blue: string;
      green: string;
      grayBackgroundColor: string;
      isMobileOrTablet: boolean;
    };
    menu: {
      mobile: {
        height: string;
      };
      desktop: {
        height: string;
      };
    };
  }

  interface ThemeOptions {
    maligue: {
      red: string;
      blue: string;
      green: string;
      grayBackgroundColor: string;
      isMobileOrTablet: boolean;
    };
    menu: {
      mobile: {
        height: string;
      };
      desktop: {
        height: string;
      };
    };
  }
}

export default function ({ children }) {
  const Experiments = useExperiments();

  const isMobileOrTablet = !!/(android|iphone|ipad)/i.test(navigator.userAgent);

  // TODO Add locale as last param (https://material-ui.com/guides/localization/)
  let theme = createTheme({
    palette: {
      secondary: {
        main: '#be2439',
      },
    },
    maligue: {
      red: '#d01a2e',
      blue: '#03498e',
      green: 'green',
      grayBackgroundColor: '#f8f8f8',
      isMobileOrTablet,
    },
    menu: {
      mobile: {
        height: '72px',
      },
      desktop: {
        height: '64px',
      },
    },
  });

  // Make the fonts responsives
  theme = responsiveFontSizes(theme);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </StyledEngineProvider>
  );
}
